import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import * as url from "../../../utils/url";
import {
  whiteLabelStyling,
  isUserRemoved,
  groupContentFields,
  displayEventDates,
  grpBannerImg,
  groupPrivacyStatusDesc,
  groupRolePriviledge,
} from "../../../utils/constants";
import { toolkitCategories } from "../../../utils/categories";
import moment from "moment";
import {
  Table,
  Modal,
  ModalBody,
  Button,
  ListGroupItem,
  Progress,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Alert,
  ModalHeader,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import noResources from "../../../assets/onboarding/toolkit.png";
import loadingItems from "../../../assets/placeholders/kpi_available.svg";
import { CSVLink } from "react-csv";
import PostTileComponent from "../../../components/PostTileComponent";
import { isMobile } from "../../../utils/deviceInfo";
import ToolDetails from "../../toolkit/ToolDetails/Details/ToolDetails";
import ReactTooltip from "react-tooltip";

const eventStaticHeaders = [
  { label: "Event Name", key: "name" },
  // { label: "Created by", key: "createdBy" },
  { label: "Start Date (Month/Day/Year)", key: "startDate" },
  { label: "End Date (Month/Day/Year)", key: "endDate" },
  { label: "Going", key: "going_count" },
  { label: "Interested", key: "interested_count" },
  { label: "Invited", key: "invitee_count" },
  { label: "Subcategory", key: "subCategory" },
  { label: "Description", key: "description" },
];

class MetricsEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "",
      events: [],
      eventsCopy: [],
      dropdownOpen: false,
      isSuccess: false,
      removedItem: null,
      isLoaded: false,
      mobileDetailsPopupOpen: false,
      popupParams: {},
      popupPath: "",
    };
  }

  componentDidMount() {
    let { id } = this.props.match.params;
    if (this.props.renderIntoMetricsPopup) {
      id = this.props.group._id;
    }
    let that = this;
    let payload = {
      groupId: id,
      modelName: "OfficeToolkit",
      modelType: "Conferences & Events",
      noLoader: true,
    };
    this.props.highlightMenu("E");
    axios.post(url.getSingleGroupItems, payload).then(({ data }) => {
      console.log("data--- ", data.data);
      that.setState({
        eventsCopy: [...data.data.items],
        events: [...data.data.items],
        isLoaded: true,
      });
    });
  }

  removeGroup = ev => {
    console.log("ev--- ", ev);
    let { events } = this.state;
    if (this.props.group) {
      let payload = {
        modelId: ev._id,
        // _id: ev._id,
        modelName: "OfficeToolkit",
        itemType: ev.category,
        groupId: this.props.group._id,
      };
      let that = this;
      axios.post(url.removeGrpItem, payload).then(({ data }) => {
        // let res=events.filter( ({modelId:doc}) => doc._id!=ev.modelId._id)
        let res = events.filter(ev => ev._id != payload.modelId);

        that.setState({
          // isRemoved:true
          events: res,
          removedItem: payload.modelId,
          isSuccess: true,
          // selected:null,
          // linkedGrp:result,  modDoc:doc,
          // groupList:[ doc ,...this.state.groupList],
          // displayItems:result
          // groupList:
          // isSuccessMsg: 0,
          // selected: {...selected, ...data.data}
        });
      });
    }
  };

  toggleMobileDetailsPopup = () => {
    if (this.state.mobileDetailsPopupOpen) {
      this.setState({ popupParams: {}, popupPath: "" });
    }
    this.setState({
      mobileDetailsPopupOpen: !this.state.mobileDetailsPopupOpen,
    });
  };

  viewTool = tool => {
    let { category } = tool;
    let tool_cat = toolkitCategories.filter(e => e.name == category)[0];
    let tool_link = `/home/toolkit/${tool_cat.link}/tool/${tool._id}`;
    if (isMobile) {
      this.setState({
        mobileDetailsPopupOpen: true,
        popupParams: {
          id: tool._id,
          category: tool_cat.link,
          popupPath: tool_link,
        },
      });
    } else {
      let { category } = tool;
      let tool_cat = toolkitCategories.filter(e => e.name == category)[0];
      let tool_link = `/home/toolkit/${tool_cat.link}/tool/${tool._id}`;
      this.props.history.push(tool_link);
    }
  };

  renderEventDates2 = event => {
    let { startDate, endDate } = event;

    if (startDate && endDate) {
      return (
        <span>
          <div>{moment(startDate).format("MMM Do, YYYY")}</div> -
          <div>{moment(endDate).format("MMM Do, YYYY")}</div>
        </span>
      );
    } else if (startDate && !endDate) {
      return (
        <span>
          <div>{moment(startDate).format("MMM Do, YYYY")}</div>
        </span>
      );
    } else if (!startDate && endDate) {
      return (
        <span>
          <div>{moment(startDate).format("MMM Do, YYYY")}</div>
        </span>
      );
    }
  };

  renderEventDates = event => {
    let { startDate, endDate } = event;

    if (startDate && endDate) {
      return (
        <span>
          {moment(startDate).format("MMM Do, YYYY")}-
          {moment(endDate).format("MMM Do, YYYY")}
        </span>
      );
    } else if ((startDate && !endDate) || (!startDate && endDate)) {
      let date = startDate && startDate != null ? startDate : endDate;
      return <span>{moment(date).format("MMM Do, YYYY")}</span>;
    }
  };

  onDismiss = () => {
    this.setState({ isSuccess: false, removedItem: null });
  };

  renderEvents = events => {
    const { orgAdmin } = this.props.user.profile;
    let { isSuccess, removedItem } = this.state;

    return (
      <span>
        {isSuccess ? (
          <Alert color="success" isOpen={isSuccess} toggle={this.onDismiss}>
            <strong>{removedItem.name}</strong> was removed.
          </Alert>
        ) : null}
        <Table
          responsive
          borderless={this.props.renderIntoMetricsPopup ? true : false}
          hover
          className="taskToolkitTable"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Category</th>
              {/* <th>Created By</th> */}
              <th>Date</th>
              <th>Participants</th>
              <th> </th>
            </tr>
          </thead>
          <tbody>
            {/* resources.map(({modelId:item},idx) => */}
            {events.map((item, idx) => {
              // ev.modelId
              let img_url =
                item.bannerImg && item.bannerImg.url
                  ? item.bannerImg.url
                  : grpBannerImg;
              return (
                <React.Fragment key={idx}>
                  <tr className="linkedToolTable" key={item._id}>
                    <td
                      onClick={() => this.viewTool(item)}
                      style={{ maxWidth: "250px" }}
                    >
                      <div className="d-flex align-items-center">
                        <span className="list-item__avatar">
                          <img src={img_url} className="fileUploadSize" />
                        </span>
                        <span
                          className="todo-item-title font-weight-bold"
                          data-tip={item.name}
                        >
                          {item.name}
                        </span>
                        <ReactTooltip />
                      </div>
                    </td>

                    <td>
                      <span className="grp_desc grp_event_list_itm_date ">
                        {item.hasOwnProperty("subCategory")
                          ? item.subCategory
                          : "No subcategory"}
                      </span>
                    </td>

                    <td>
                      <span className="grp_desc grp_event_list_itm_date">
                        {/* {this.renderEventDates(itm)} */}
                        {displayEventDates(item, true, false, true)}
                      </span>
                    </td>

                    <td>
                      <span className="grp_desc grp_event_item_alt_color grp_event_list_itm_rsvp">
                        {item.interested_count} interested · {item.going_count}{" "}
                        going
                      </span>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </Table>

        {/* <div className="singleTaskToolkitTableContainerBox">
              <Table responsive hover className="taskToolkitTable">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Category</th>
                      <th> Event Dates </th>
                      <th>Date Added</th>
                      <th> </th>
                    </tr>
                  </thead>
                  <tbody>
                
                  { events.map(({modelId:item},idx) => {
                      return <React.Fragment key={idx+item._id}>
                        <tr className="linkedToolTable" key={item._id} >
                                <td >
                                  {item.name}  <span className="linkedToolView" onClick={()=>this.viewTool(item)}>(view)</span>
                                </td>
                                                    
                                <td >
                                  {item.category}                    
                                </td>


                                <td className="grp_single_page_event_date_css">
                                  {this.renderEventDates(item)}
                                </td>
                      
                              
                      
                                <td className="grp_single_page_event_date_css">
                                  {moment(item.createdAt).format('MMM Do, YYYY')}                   
                                </td>
                               
                          {groupRolePriviledge({role:this.props.currentRole, action:0, 
                           role_priv:[0,1,2], comparison:null, isAdmin:this.props.currentRole==0}) 
                           || (item.userId ==  this.props.user.profile._id)
                           ?
                                <td className="grp_single_page_remove_css">
                                <span onClick={()=>this.removeGroup(item)} className='chart-item-menu flaticon-trash'/>                
                                </td>
                                :null}

                              </tr>
                        </React.Fragment>
                  })}
                
                </tbody>
              </Table>
              </div> */}
      </span>
    );
  };

  goToEvents = () => {
    this.props.history.push("/home/toolkit/conferences-events");
  };

  createEvent = () => {
    // .replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()

    this.props.history.push(
      `/home/toolkit/${this.props.group._id}/conferences-events/add`
    );
  };

  getCreatedByName = item => {
    if (
      item["firstName"] !== undefined &&
      item["lastName"] !== undefined &&
      !isEmpty(item.firstName) &&
      !isEmpty(item.lastName)
    ) {
      return `${item.firstName} ${item.lastName}`;
    }
    return "NA";
  };

  createTextValue = val => {
    let temp = document.createElement("p");
    temp.innerHTML = val;
    let text = temp.textContent || temp.innerText;
    temp = null;
    return text;
    // let text=  val.toString().replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "")
    //            .replace (/(^")|("$)/g, '')
    //            .replace(/^[ ]+|[ ]+$/g,'')
    //            .replace(/\s+/g, ' ')
    //            .replace(/,/g, "")
    //            .replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ');
    //  return text
  };

  getData = data => {
    let csvData = [];
    if (data && data.length > 0) {
      data.map(value => {
        let event_row = {};
        eventStaticHeaders.map(row => {
          let { label, key } = row;
          event_row[label] = `${value[key]}`;
          if (key == "description") {
            event_row[label] = this.createTextValue(value[key]);
          }
          if (key == "startDate" || key == "endDate") {
            event_row[label] = `${moment(value[key]).format("M/D/YYYY")}`;
          }

          // if(key=='createdBy'){
          //   let firstName = value['key']
          //   event_row[label] = `${value[key].format('D/M/YYYY')}`
          // }
        });
        csvData.push(event_row);
      });
    }

    return csvData;
  };

  handleSearchQueryChanged = e => {
    const val = e.target.value;
    const { eventsCopy } = this.state;
    if (val) {
      const newEvents = eventsCopy.filter(x =>
        x.name.toLowerCase().includes(val.toLowerCase())
      );
      this.setState({ events: [...newEvents] });
    } else {
      this.setState({ events: [...eventsCopy] });
    }
  };

  render() {
    let { events, isLoaded, mobileDetailsPopupOpen } = this.state;
    let { renderIntoMetricsPopup, eventsPopupOpen, toggle } = this.props;

    return (
      <Modal isOpen={eventsPopupOpen}>
        <ModalHeader toggle={toggle} className="metrics-mobile-header">
          Group Events
          {events.length ? (
            <span
              className={`single_group_menu_events_export_btn ${
                isMobile ? "" : "ml-5"
              }`}
            >
              <CSVLink
                data={
                  //  [
                  //     { firstname: "Ahmed", lastname: "Tomi", email: "ah@smthing.co.com" },
                  //     { firstname: "Raed", lastname: "Labes", email: "rl@smthing.co.com" },
                  //     { firstname: "Yezzi", lastname: "Min l3b", email: "ymin@cocococo.com" }
                  //   ]

                  this.getData(events)
                }
                // headers={eventStaticHeaders}
                filename={`Group Events - ${moment().format("MM/DD/YYYY")}.csv`}
                target="_blank"
              >
                {events && events.length > 0
                  ? "Export Group Events to CSV"
                  : "No events"}
              </CSVLink>
            </span>
          ) : (
            ""
          )}
        </ModalHeader>
        <ModalBody>
          <span
            className={
              renderIntoMetricsPopup
                ? ""
                : `grp_single_page_stories_container resources_component_container`
            }
          >
            {mobileDetailsPopupOpen && (
              <Modal
                isOpen={mobileDetailsPopupOpen}
                toggle={this.toggleMobileDetailsPopup}
              >
                <ModalHeader toggle={this.toggleMobileDetailsPopup}>
                  View Event
                </ModalHeader>
                <ModalBody>
                  <ToolDetails
                    match={{ params: this.state.popupParams }}
                    isPopup={true}
                    history={{
                      location: { pathname: this.state.popupPath, search: "" },
                      ...this.props.history,
                    }}
                  />
                </ModalBody>
              </Modal>
            )}
            <span
              className={
                renderIntoMetricsPopup
                  ? ""
                  : "grp_single_detail_page_container_rmenu_events"
              }
            >
              <div className="search-export-button-div">
                <InputGroup style={{ height: "40px" }}>
                  <Input
                    className="toolkit-field tool-search-box"
                    placeholder="Search ..."
                    onChange={this.handleSearchQueryChanged}
                  />
                  <InputGroupAddon addonType="append">
                    <i
                      style={{ color: "#818389", padding: "7px" }}
                      className="flaticon-search"
                    ></i>
                  </InputGroupAddon>
                </InputGroup>
              </div>
            </span>

            {isLoaded != true && !renderIntoMetricsPopup ? (
              <div
                className={
                  renderIntoMetricsPopup
                    ? "grp_single_page_metrics_popup_container"
                    : `grp_single_page_details_analytics_container`
                }
              >
                <span
                  className={
                    renderIntoMetricsPopup
                      ? "grp_single_page_metrics"
                      : "grp_single_page_no_analytics"
                  }
                >
                  <img src={loadingItems} className="grpNoLinkedCharts" />{" "}
                  Loading...
                </span>
              </div>
            ) : isLoaded ? (
              events && events.length > 0 ? (
                <div
                  className={
                    renderIntoMetricsPopup
                      ? ""
                      : "grp_single_page_resources_component_container"
                  }
                >
                  {this.renderEvents(events)}
                </div>
              ) : (
                <div
                  className={
                    renderIntoMetricsPopup
                      ? "grp_single_page_metrics_popup_container"
                      : `grp_single_page_details_analytics_container`
                  }
                >
                  <span className="grp_single_page_no_analytics">
                    <img src={noResources} className="grpNoLinkedCharts" />

                    <div className="grp_page_events_title">
                      No events have been created for this Group.
                    </div>

                    <div
                      className="grp_page_events_subtitle"
                      onClick={() => this.goToEvents()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="currentColor"
                        class=""
                        viewBox="0 0 16 16"
                      >
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                      </svg>
                      Find an Event to link
                    </div>
                  </span>
                </div>
              )
            ) : null}
          </span>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(MetricsEvents, axios)));
